<template>
<Navbar/>
    <div v-if="isLoading"
     class="row justify-content-md-center">
        <div class="col-3 alert-info text-center mt-5" >
            espere porfavor...
            <h3 class="mt-2">
                <i class="fa fa-spin fa-sync"></i>
            </h3>
        </div>

    </div>
<div v-else
 class="d-flex">
    <div class="col-7">
        <router-view/>
    </div>
    <div class="col" id="scrollTarget">
        <NoEntrySelect/>
    </div>
</div>

</template>

<script>
import {defineAsyncComponent} from 'vue'
import {mapActions, mapState} from 'vuex'
export default{
    components:{
        Navbar: defineAsyncComponent(()=> import('../components/Navbar.vue')),
        NoEntrySelect: defineAsyncComponent(()=> import('../views/NoEntrySelected.vue')),
    },
    methods:{
        ...mapActions('journal', ['loadEntries'])
    },
    computed:{
        ...mapState('journal', ['isLoading'])
    },
    created(){
        this.loadEntries()
    }
}
</script>
<style lang="scss" scoped>

@media (max-width: 400px) {
    .d-flex {
    display: flex !important;
    flex-wrap: wrap !important;
}
#scrollTarget{
    display: none  !important;;
}
.col {
    flex: 1 0 0%;
    width: 80% !important;
}.col-7 {
    flex: 1 0 0%;
    width: 100% !important;
}th  {
    padding: 0.2rem 0.3rem !important;
   
}.entry-scrollarea {
    height: calc(100vh - 240px)  !important;
    overflow: scroll;
}
}

@media (max-width: 800px) {
    .d-flex {
    display: flex !important;
    flex-wrap: wrap !important;
}
#scrollTarget{
    display: none  !important;;
}
.col {
    flex: 1 0 0%;
    width: 80% !important;
}.col-7 {
    flex: 1 0 0%;
    width: 100% !important;
}th  {
    padding: 0.2rem 0.3rem !important;
   
}.entry-scrollarea {
    height: calc(100vh - 240px)  !important;
    overflow: scroll;
}
}

#scrollTarget{
    background-image: url('https://media.tenor.com/TcJPgY0dm18AAAAd/gym-time-exercise.gif');
    background-size: cover;
    background-position: center;
    background-size: cover;
}
</style>